import { Component } from '@angular/core';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'app-in-navbar',
  templateUrl: './in-navbar.component.html',
  styleUrls: ['./in-navbar.component.css']
})
export class InNavbarComponent {
  env: any = Environment;
  debug: string = this.env.app.debug;
  title: string = this.env.app.title;
}
